/* eslint-disable */
import { combineReducers, } from 'redux';
import { reducer as reduxFormReducer, } from 'redux-form';

export default combineReducers({
  reduxFormReducer,
});